/* eslint-disable no-useless-escape */
export enum EMPTY_FIELD_MESSAGE {
  SPACE_BAR = 'เนื่องจากมีข้อมูลที่เป็นช่องว่างอยู่ กรุณาระบุข้อมูลให้ถูกต้อง',
}

export const validateTextEn = /^[^ก-๙๐-๙]*$/;

export const checkMessageEn = (message: string) => {
  return validateTextEn.test(message);
};

export const validateEditorEn = /^[^ก-๙๐-๙]+$/;

export const checkEditorMessageEn = (message: string) => {
  return validateEditorEn.test(message);
};

export const validateUrl =
  /^(https?:\/\/)?([a-zA-Z0-9\u0E00-\u0E7F-]+\.)+[a-zA-Z\u0E00-\u0E7F]{2,}(\/[a-zA-Z0-9\u0E00-\u0E7F\-._~:/?#[\]@!$&'()*+,;%=]*)?$/;

export const validateEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const checkMessageUrl = (message: string) => {
  return validateUrl.test(message);
};

const isNotEmptyString = (value: string): boolean => {
  return typeof value === 'string' && value.trim().length > 0;
};

export const validateThaiDescription = (
  descriptions: Array<{ titleTh: string; descriptionTh: string }>
) => {
  if (!descriptions || descriptions.length === 0) return true;

  return descriptions.every(
    (item) =>
      isNotEmptyString(item.titleTh) &&
      isNotEmptyString(item.descriptionTh) &&
      validateSpace(item.descriptionTh)
  );
};

export const validateEnglishDescription = (
  descriptions: Array<{ titleEn: string; descriptionEn: string }>
) => {
  if (!descriptions || descriptions.length === 0) return true;

  return descriptions.every(
    (item) =>
      isNotEmptyString(item.titleEn) &&
      isNotEmptyString(item.descriptionEn) &&
      validateEditorEn.test(item.titleEn) &&
      validateEditorEn.test(item.descriptionEn) &&
      validateSpace(item.descriptionEn)
  );
};

export const validateSpace = (value?: string | null): boolean => {
  const strippedValue = value?.replace(/<\/?p>/g, '').trim();
  return strippedValue !== '' && !/^\s+$/.test(strippedValue || '');
};

export const validateSpaceTextInput = (value?: string | null): boolean => {
  if (!value) return true;
  const onlyWhitespace = /^\s+$/;
  return !onlyWhitespace.test(value);
};
